import PayVault from "./PayVault";
export default function App() { return <PayVault />; }